import { POST } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['PublicAuthenticateVerifyOtpController_post'];

export type PublicAuthenticationVerifyOtpBody = controller['requestBody']['content']['application/json'];
export type PublicAuthenticationVerifyOtpResponse = controller['responses']['200']['content']['application/json'];

export const verifyOtp = POST('/public/authenticate/verify-otp')<
  PublicAuthenticationVerifyOtpBody,
  PublicAuthenticationVerifyOtpResponse
>;
